const ProgrammeData = [
    {
      "value": "Computer Engineering",
      "label": "Computer Engineering",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Computer Science and Engineering (SCSE)"
      ]
    },
    {
      "value": "Mechanical Engineering",
      "label": "Mechanical Engineering",
      "faculty": ["School of Mechanical and Aerospace Engineering (MAE)"]
    },
    {
      "value": "Linguistics & Multilingual Studies",
      "label": "Linguistics & Multilingual Studies",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Psychology",
      "label": "Psychology",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Accountancy And Data Science & Artificial Intelligence",
      "label": "Accountancy And Data Science & Artificial Intelligence",
      "faculty": [
        "Nanyang Business School (NBS)",
        "School of Computer Science and Engineering (SCSE)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "C N Yang Scholars Programme",
      "label": "C N Yang Scholars Programme",
      "faculty": ["C N Yang Scholars Programme"]
    },
    {
      "value": "Linguistics & Multilingual Studies And English",
      "label": "Linguistics & Multilingual Studies And English",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Mathematics & Economics",
      "label": "Mathematics & Economics",
      "faculty": [
        "School of Social Sciences (SSS)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Chinese And English",
      "label": "Chinese And English",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Chemistry and Biological Chemistry",
      "label": "Chemistry and Biological Chemistry",
      "faculty": [
        "School of Biological Sciences (SBS)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Art, Design & Media",
      "label": "Art, Design & Media",
      "faculty": ["School of Art, Design and Media (ADM)"]
    },
    {
      "value": "Electrical & Electronic Engineering And Economics",
      "label": "Electrical & Electronic Engineering And Economics",
      "faculty": [
        "School Electrical and Electronic Engineering (EEE)",
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Liberal Arts",
      "label": "Liberal Arts",
      "faculty": ["University Scholars Programme (USP)"]
    },
    {
      "value": "Business",
      "label": "Business",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Mathematical Sciences",
      "label": "Mathematical Sciences",
      "faculty": ["School of Physical and Mathematical Sciences (SPMS)"]
    },
    {
      "value": "Nanyang Technopreneurship Centre",
      "label": "Nanyang Technopreneurship Centre",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Materials Engineering",
      "label": "Materials Engineering",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Materials Science and Engineering (MSE)"
      ]
    },
    {
      "value": "Mathematical And Computer Sciences",
      "label": "Mathematical And Computer Sciences",
      "faculty": [
        "School of Computer Science and Engineering (SCSE)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Biomedical Sciences",
      "label": "Biomedical Sciences",
      "faculty": ["School of Biological Sciences (SBS)"]
    },
    {
      "value": "Electrical & Electronic Engineering",
      "label": "Electrical & Electronic Engineering",
      "faculty": [
        "School Electrical and Electronic Engineering (EEE)",
        "School of Mechanical and Aerospace Engineering (MAE)"
      ]
    },
    {
      "value": "Bioengineering",
      "label": "Bioengineering",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Chemical and Biomedical Engineering (SCBE)"
      ]
    },
    {
      "value": "Bioengineering And Economics",
      "label": "Bioengineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Chemical and Biomedical Engineering (SCBE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Biological Sciences",
      "label": "Biological Sciences",
      "faculty": ["School of Biological Sciences (SBS)"]
    },
    {
      "value": "Computer Science And Economics",
      "label": "Computer Science And Economics",
      "faculty": [
        "School of Computer Science and Engineering (SCSE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Business And Computer Engineering",
      "label": "Business And Computer Engineering",
      "faculty": [
        "Nanyang Business School (NBS)",
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Computer Science and Engineering (SCSE)"
      ]
    },
    {
      "value": "Public Policy And Global Affairs",
      "label": "Public Policy And Global Affairs",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Youth Work And Guidance",
      "label": "Youth Work And Guidance",
      "faculty": ["SkillsFuture Work-Study Degree Programmes (WSDPs)"]
    },
    {
      "value": "English",
      "label": "English",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Medicine",
      "label": "Medicine",
      "faculty": ["Lee Kong Chian School of Medicine (LKCM)"]
    },
    {
      "value": "History And Chinese",
      "label": "History And Chinese",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Maritime Studies",
      "label": "Maritime Studies",
      "faculty": ["School of Civil and Environmental Engineering (CEE)"]
    },
    {
      "value": "University Scholars Programme in Science, Technology & Society",
      "label": "University Scholars Programme in Science, Technology & Society",
      "faculty": [
        "Institute of Science and Technology for Humanity (NISTH)",
        "University Scholars Programme (USP)"
      ]
    },
    {
      "value": "University Scholars Programme",
      "label": "University Scholars Programme",
      "faculty": ["University Scholars Programme (USP)"]
    },
    {
      "value": "Computer Engineering And Economics",
      "label": "Computer Engineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Computer Science and Engineering (SCSE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Drama And Performance",
      "label": "Drama And Performance",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Materials Engineering And Economics",
      "label": "Materials Engineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Materials Science and Engineering (MSE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Engineering",
      "label": "Engineering",
      "faculty": ["School of Mechanical and Aerospace Engineering (MAE)"]
    },
    {
      "value": "Physics and Applied Physics",
      "label": "Physics and Applied Physics",
      "faculty": ["School of Physical and Mathematical Sciences (SPMS)"]
    },
    {
      "value": "Education Studies",
      "label": "Education Studies",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Design And Systems Thinking",
      "label": "Design And Systems Thinking",
      "faculty": ["Centre for Teaching, Learning & Pedagogy (CTLP)"]
    },
    {
      "value": "Accountancy",
      "label": "Accountancy",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Philosophy And Chinese",
      "label": "Philosophy And Chinese",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Chemical & Biomolecular Engineering",
      "label": "Chemical & Biomolecular Engineering",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Chemical and Biomedical Engineering (SCBE)"
      ]
    },
    {
      "value": "History",
      "label": "History",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Economics And Psychology",
      "label": "Economics And Psychology",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Biological Sciences And Psychology",
      "label": "Biological Sciences And Psychology",
      "faculty": [
        "School of Social Sciences (SSS)",
        "School of Biological Sciences (SBS)"
      ]
    },
    {
      "value": "English Literature And Art History",
      "label": "English Literature And Art History",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Psychology And Linguistics & Multilingual Studies",
      "label": "Psychology And Linguistics & Multilingual Studies",
      "faculty": ["School of Humanities (SOH)", "School of Social Sciences (SSS)"]
    },
    {
      "value": "Science, Technology & Society",
      "label": "Science, Technology & Society",
      "faculty": ["Institute of Science and Technology for Humanity (NISTH)"]
    },
    {
      "value": "Economics",
      "label": "Economics",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Linguistics & Multilingual Studies And Philosophy",
      "label": "Linguistics & Multilingual Studies And Philosophy",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Physical and Mathematical Sciences",
      "label": "Physical and Mathematical Sciences",
      "faculty": ["School of Physical and Mathematical Sciences (SPMS)"]
    },
    {
      "value": "Environmental Engineering And Economics",
      "label": "Environmental Engineering And Economics",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Data Science And Artificial Intelligence",
      "label": "Data Science And Artificial Intelligence",
      "faculty": [
        "School of Computer Science and Engineering (SCSE)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Philosophy",
      "label": "Philosophy",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Environmental Earth Systems Science",
      "label": "Environmental Earth Systems Science",
      "faculty": ["The Asian School of the Environment (ASE)"]
    },
    {
      "value": "Sport Science And Management",
      "label": "Sport Science And Management",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Communication Studies",
      "label": "Communication Studies",
      "faculty": ["Wee Kim Wee School of Communication and Information (WKWSCI)"]
    },
    {
      "value": "Environmental Earth Systems Science And Public Policy & Global Affairs",
      "label": "Environmental Earth Systems Science And Public Policy & Global Affairs",
      "faculty": [
        "School of Social Sciences (SSS)",
        "The Asian School of the Environment (ASE)"
      ]
    },
    {
      "value": "Information Engineering & Media",
      "label": "Information Engineering & Media",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)"
      ]
    },
    {
      "value": "English And Philosophy",
      "label": "English And Philosophy",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "University Scholars Programme in Arts, Humanities and Culture",
      "label": "University Scholars Programme in Arts, Humanities and Culture",
      "faculty": [
        "School of Humanities (SOH)",
        "University Scholars Programme (USP)"
      ]
    },
    {
      "value": "Sociology",
      "label": "Sociology",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Social Sciences",
      "label": "Social Sciences",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Science Of Learning",
      "label": "Science Of Learning",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Early Childhood Education",
      "label": "Early Childhood Education",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Civil Engineering And Economics",
      "label": "Civil Engineering And Economics",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Business And Computing",
      "label": "Business And Computing",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Philosophy And History",
      "label": "Philosophy And History",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Business & Management",
      "label": "Business & Management",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Civil Engineering",
      "label": "Civil Engineering",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)"
      ]
    },
    {
      "value": "Physics And Mathematical Sciences",
      "label": "Physics And Mathematical Sciences",
      "faculty": ["School of Physical and Mathematical Sciences (SPMS)"]
    },
    {
      "value": "Accountancy And Business",
      "label": "Accountancy And Business",
      "faculty": ["Nanyang Business School (NBS)"]
    },
    {
      "value": "Renaissance Engineering",
      "label": "Renaissance Engineering",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "Renaissance Engineering Programme (REP)"
      ]
    },
    {
      "value": "Information Engineering & Media And Economics",
      "label": "Information Engineering & Media And Economics",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Economics And Data Science",
      "label": "Economics And Data Science",
      "faculty": [
        "School of Computer Science and Engineering (SCSE)",
        "School of Social Sciences (SSS)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Mechanical Engineering And Economics",
      "label": "Mechanical Engineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "English And History",
      "label": "English And History",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Economics And Media Analytics",
      "label": "Economics And Media Analytics",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Mathematical Sciences And Economics",
      "label": "Mathematical Sciences And Economics",
      "faculty": [
        "School of Social Sciences (SSS)",
        "School of Physical and Mathematical Sciences (SPMS)"
      ]
    },
    {
      "value": "Chinese And Linguistics & Multilingual Studies",
      "label": "Chinese And Linguistics & Multilingual Studies",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Music",
      "label": "Music",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Humanities",
      "label": "Humanities",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Aerospace Engineering And Economics",
      "label": "Aerospace Engineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "Environmental Engineering",
      "label": "Environmental Engineering",
      "faculty": [
        "School of Civil and Environmental Engineering (CEE)",
        "School of Mechanical and Aerospace Engineering (MAE)"
      ]
    },
    {
      "value": "Biomedical Sciences And Biobusiness",
      "label": "Biomedical Sciences And Biobusiness",
      "faculty": [
        "Nanyang Business School (NBS)",
        "School of Biological Sciences (SBS)"
      ]
    },
    {
      "value": "Psychology And Media Analytics",
      "label": "Psychology And Media Analytics",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Computer Science",
      "label": "Computer Science",
      "faculty": ["School of Computer Science and Engineering (SCSE)"]
    },
    {
      "value": "Economics And Public Policy & Global Affairs",
      "label": "Economics And Public Policy & Global Affairs",
      "faculty": ["School of Social Sciences (SSS)"]
    },
    {
      "value": "Special Needs Education",
      "label": "Special Needs Education",
      "faculty": ["National Institute of Education (NIE)"]
    },
    {
      "value": "Chemical & Biomolecular Engineering And Economics",
      "label": "Chemical & Biomolecular Engineering And Economics",
      "faculty": [
        "School of Mechanical and Aerospace Engineering (MAE)",
        "School of Chemical and Biomedical Engineering (SCBE)",
        "School of Social Sciences (SSS)"
      ]
    },
    {
      "value": "History And Linguistics & Multilingual Studies",
      "label": "History And Linguistics & Multilingual Studies",
      "faculty": ["School of Humanities (SOH)"]
    },
    {
      "value": "Aerospace Engineering",
      "label": "Aerospace Engineering",
      "faculty": ["School of Mechanical and Aerospace Engineering (MAE)"]
    },
    {
      "value": "Chinese",
      "label": "Chinese",
      "faculty": ["School of Humanities (SOH)"]
    }
];

export default ProgrammeData;
